import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/Support",
      name: "support",
      meta: { requiresAuth: true, title: "routes.support" },
      component: () => import("./main.vue")
    }
  ]
};
